var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClinical7({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 107,
    viewBox: "0 0 117 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 117,
    height: 107,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_5285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.6247 69.9083C61.6536 69.9041 61.6811 69.8981 61.7072 69.8909C61.7179 70.0183 61.728 70.1696 61.7374 70.3486C61.7851 71.2594 61.8097 72.806 61.8097 75.3737C61.8097 85.3655 53.6624 93.5 43.6548 93.5C33.6473 93.5 25.5 85.3655 25.5 75.3737C25.5 69.8708 27.9624 64.737 32.2731 61.2731L32.4599 61.123V60.8834V23.6735C32.4599 17.5183 37.4837 12.5 43.6548 12.5C49.8262 12.5 54.8498 17.5113 54.8498 23.6735V39.1271L51.072 45.2393V23.7591C51.072 19.5875 47.6709 16.1373 43.482 16.2137C39.4363 16.2827 36.1664 19.6078 36.1664 23.6735V62.93L34.7381 64.0563C34.4113 64.3141 34.0918 64.5563 33.7823 64.7909C32.5486 65.7261 31.4707 66.5431 30.6972 67.7711C29.7129 69.3335 29.2279 71.5168 29.2279 75.3808C29.2279 83.3293 35.6836 89.7935 43.6192 89.7935C51.5547 89.7935 58.0105 83.3293 58.0105 75.3808C58.0105 73.3048 57.5688 71.2908 56.7405 69.4557H60.8505C60.9301 69.5954 61.0298 69.7197 61.1608 69.8045C61.2982 69.8936 61.4596 69.9326 61.6247 69.9083Z",
    fill: "#05054B",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0796 71.6655V38.5061C46.0796 37.1671 44.9941 36.0815 43.655 36.0815C42.316 36.0815 41.2305 37.1671 41.2305 38.5061V71.6655C41.2305 73.0046 42.316 74.0901 43.655 74.0901C44.9941 74.0901 46.0796 73.0046 46.0796 71.6655Z",
    fill: "#DD1160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9809 75.4807C52.9809 81.3852 47.4828 86.0132 41.3216 84.5228C38.027 83.7313 35.4242 81.157 34.6113 77.8696C33.2421 72.3287 36.8076 67.3013 41.8635 66.3173V66.0962H45.4291V66.3173C49.722 67.1516 52.9809 70.9382 52.9809 75.4807Z",
    fill: "#DD1160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6784 75.3568C81.6511 75.3568 91.3568 65.6511 91.3568 53.6784C91.3568 41.7058 81.6511 32 69.6784 32C57.7058 32 48 41.7058 48 53.6784C48 65.6511 57.7058 75.3568 69.6784 75.3568Z",
    fill: "#DD1160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5 35C59.2848 35 51 43.2848 51 53.5C51 63.7152 59.2848 72 69.5 72C79.7152 72 88 63.7152 88 53.5C88 43.2848 79.7152 35 69.5 35ZM68.2933 63.3904C67.9027 63.7804 67.27 63.7801 66.8797 63.3898L58.823 55.3331C58.4328 54.9429 58.4325 54.3103 58.8223 53.9196L61.4277 51.3089C61.8181 50.9177 62.4518 50.9173 62.8426 51.3082L66.8785 55.344C67.2693 55.7348 67.9029 55.7345 68.2933 55.3434L76.8457 46.7768C77.2362 46.3857 77.8698 46.3855 78.2605 46.7762L80.8881 49.4038C81.2789 49.7945 81.2786 50.4282 80.8875 50.8186L68.2933 63.3904Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_5285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 82,
    fill: "white",
    transform: "translate(25 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinical7);
export default __webpack_public_path__ + "static/media/clinical_7.cf878342970d052772b5cb39dbb81e0e.svg";
export { ForwardRef as ReactComponent };